module.exports = __webpack_public_path__ + "static/media/jl_face.2a41fb0d.png";